import React, { useCallback, useState } from "react";
import styled from "styled-components";

import { PresenceStatus } from "--root/static_types/presence.types";
import { Strings } from "--root/strings/en";

import { SwaggerMutateClient } from "--client/common/apis/rest";
import { useLoggedInUser } from "--client/common/hooks/useLoggedInUser";

import SurfaceHeader from "--floponents-web/atoms/Surface/SurfaceHeader";
import { Heading5 } from "--components/typography";
import { DialogCloseButton } from "--floponents-web/molecules/DialogCloseButton/DialogCloseButton";

import { usePresence } from "../../../common/hooks/usePresence";
import { StatusForm } from "./StatusForm";

const StyledStatusDialog = styled.div`
    display: contents;
`;

export interface StatusDialogProps {
    onClose?: () => void;
}
export const StatusDialog = (props: StatusDialogProps) => {
    const { onClose } = props;

    const userId = useLoggedInUser();
    const presence = usePresence(userId.user_or_identity_id);

    const [isWorking, setIsWorking] = useState(false);

    const handleSubmit = useCallback(async (status?: PresenceStatus) => {
        setIsWorking(true);
        await SwaggerMutateClient.SetUserStatus({ status });
        setIsWorking(false);
        onClose?.();
    }, [onClose]);

    return (
        <StyledStatusDialog>
            <SurfaceHeader>
                <Heading5>{Strings.status.statusDialogTitle}</Heading5>
                <DialogCloseButton onClick={onClose} />
            </SurfaceHeader>
            {presence && (
                <StatusForm
                    initialStatus={presence.status}
                    isWorking={isWorking}
                    onSubmit={handleSubmit}
                    onCancel={props.onClose}
                />
            )}
        </StyledStatusDialog>
    );
};
